<template>
  <div id="footer">
    <div class="footer_main1 flex_sw">
      <img
        class="footer_main1_logo"
        src="@/assets/images/footer/logo.png"
        alt=""
      />
      <div class="footer_main1_er">
        <div class="footer_main1_er_item">
          <img :src="urls + config.wechat_qrcode" alt="" />
          <div>{{ zh == "cn" ? "德瑞光电" : "Derui Optoelectronics" }}</div>
        </div>
        <div class="footer_main1_er_item">
          <img :src="urls + config.web_qrocde" alt="" />
          <div>{{ zh == "cn" ? "移动端" : "Mobile terminal" }}</div>
        </div>
      </div>
    </div>
    <div class="footer_main2 flex_sw">
      <div class="footer_main2_left">
        <div class="company" v-for="item in companyList" :key="item.id">
          <div class="company_left">
            {{ zh == "cn" ? item.title : item.title_en }}
          </div>
          <div class="company_right">
            <div class="company_item w2" v-if="zh == 'cn' && item.phone">
              {{ item.id == 1 ? "全国服务热线" : "电话" }}：{{ item.phone }}
            </div>
            <div class="company_item w2" v-if="zh == 'en' && item.phone">
              {{ item.id == 1 ? "contact" : "Phone" }}：{{ item.phone }}
            </div>
            <div class="company_item w2" v-if="item.chuanzhen">
              {{ zh == "cn" ? "传真" : "fax" }}：{{ item.chuanzhen }}
            </div>
            <div class="company_item" v-if="item.email">
              {{ zh == "cn" ? "邮箱" : "email" }}：{{ item.email }}
            </div>
            <div class="company_item" v-if="item.address || item.address_en">
              {{ zh == "cn" ? "地址" : "address" }}：{{
                zh == "cn" ? item.address : item.address_en
              }}
            </div>
            <div class="company_item" v-if="item.remark || item.remark_en">
              {{ zh == "cn" ? item.remark : item.remark_en }}
            </div>
          </div>
        </div>
      </div>
      <div class="footer_main2_right">
        <div class="nav_item" v-for="item in navList" :key="item.id">
          <div class="nav_item_title" @click="handleTo(item)">
            {{ zh == "cn" ? item.name : item.name_en }}
          </div>
          <div class="nav_item_list" v-if="item.child.length != 0">
            <div
              class="nav_item_name"
              v-for="items in item.child"
              :key="items.id"
              @click="handleTo(items)"
            >
              {{ zh == "cn" ? items.name : items.name_en }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_main3 flex_center">
      <div>Copyright © 江西德瑞光电技术有限责任公司</div>
      <a class="mr" href="https://beian.miit.gov.cn/" target="_blank"
        >备案号：{{ config.beian }}</a
      >
      <a href="http://jx.dinfen.com/" target="_blank">技术支持：鼎峰互动</a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      config: {},
      urls: this.imgurl,
      navList: [],
      zh: localStorage.getItem("zh") || "cn",
      companyList: [],
    };
  },
  mounted() {
    this.indexGetcompany();
    this.indexGetconfig();
  },
  methods: {
    //获取分部
    async indexGetcompany() {
      let res = await this.$api.indexGetcompany();
      if (res.code == 1) {
        this.companyList = res.data;
      }
    },
    //到底部及公共配置数据
    async indexGetconfig() {
      let res = await this.$api.indexGetconfig();
      if (res.code == 1) {
        this.config = res.data;
        setTimeout(() => {
          this.$parent.$refs.header.phone = this.config.phone;
          let arr = [...this.$parent.$refs.header.navList];
          this.navList = arr.splice(1, arr.length - 1);
        }, 300);
      }
    },
    handleTo(item) {
      this.$router.push(item.route);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style lang="less" scoped>
#footer {
  padding: 0 0.37rem;
  background-color: #25242f;
  .footer_main1 {
    height: 0.938rem;
    .footer_main1_logo {
      width: 1.042rem;
      height: 0.318rem;
      display: block;
    }
    .footer_main1_er {
      display: flex;
      .footer_main1_er_item {
        font-size: 0.063rem;
        color: #fff;
        text-align: center;
        &:first-child {
          margin-right: 0.156rem;
        }
        img {
          width: 0.417rem;
          height: 0.417rem;
          display: block;
          margin: 0 auto 0.052rem;
        }
      }
    }
  }
  .footer_main2 {
    align-items: flex-start;
    padding: 0.307rem 0 0.302rem;
    color: #999;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    .footer_main2_left {
      width: 4.115rem;
      .company {
        display: flex;
        .company_left {
          font-size: 0.125rem;
          color: #fff;
          flex-shrink: 0;
          width: 0.958rem;
        }
        .company_right {
          display: flex;
          flex-wrap: wrap;
          font-size: 0.083rem;
          line-height: 0.12rem;
          .company_item {
            margin-bottom: 0.151rem;
            margin-right: 2%;
          }
          .w2 {
            width: 49%;
          }
        }
      }
    }
    .footer_main2_right {
      display: flex;
      .nav_item {
        line-height: 0.12rem;
        margin-right: 0.401rem;
        &:last-child {
          margin-right: 0;
        }
        .nav_item_title {
          font-size: 0.094rem;
          color: #fff;
          margin-bottom: 0.156rem;
          &:hover {
            color: #e5322d;
            cursor: pointer;
          }
        }
        .nav_item_name {
          font-size: 0.083rem;
          color: #999;
          margin-bottom: 0.146rem;
          max-width: 0.625rem;
          &:hover {
            color: #e5322d;
            cursor: pointer;
          }
        }
      }
    }
  }
  .footer_main3 {
    font-size: 0.083rem;
    color: #999;
    height: 0.365rem;
    a {
      font-size: 0.083rem;
      color: #999;
      text-decoration: none;
      &:hover {
        color: #e5322d;
      }
    }
    .mr {
      margin: 0 0.156rem;
    }
  }
}
@media (max-width: 680px) {
  #footer {
    padding: 0 20px;
    background-color: #25242f;
    .footer_main1 {
      height: 100%;
      padding: 16px 0;
      .footer_main1_logo {
        width: 100px;
        height: auto;
        display: block;
      }
      .footer_main1_er {
        display: flex;
        .footer_main1_er_item {
          font-size: 12px;
          color: #fff;
          text-align: center;
          &:first-child {
            margin-right: 20px;
          }
          img {
            width: 80px;
            height: 80px;
            display: block;
            margin: 0 auto 10px;
          }
        }
      }
    }
    .footer_main2 {
      display: block;
      align-items: flex-start;
      padding: 20px 0 ;
      color: #999;
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      border-top: 1px solid rgba(255, 255, 255, 0.3);
      .footer_main2_left {
        width: 100%;
        .company {
          display: block;
          .company_left {
            font-size: 16px;
            color: #fff;
            flex-shrink: 0;
            width: 100%;
          }
          .company_right {
            display: flex;
            flex-wrap: wrap;
            font-size: 14px;
            line-height: 28px;
            .company_item {
              margin-bottom: 16px;
            }
            .w2 {
              width: 100%;
            }
          }
        }
      }
      .footer_main2_right {
        display: none;
        .nav_item {
          line-height: 0.12rem;
          margin-right: 0.401rem;
          &:last-child {
            margin-right: 0;
          }
          .nav_item_title {
            font-size: 0.094rem;
            color: #fff;
            margin-bottom: 0.156rem;
            &:hover {
              color: #e5322d;
              cursor: pointer;
            }
          }
          .nav_item_name {
            font-size: 0.083rem;
            color: #999;
            margin-bottom: 0.146rem;
            max-width: 0.625rem;
            &:hover {
              color: #e5322d;
              cursor: pointer;
            }
          }
        }
      }
    }
    .footer_main3 {
      font-size: 14px;
      color: #999;
      height: 100%;
      min-height: 46px;
      flex-wrap: wrap;
      padding: 10px 0;
      a {
        font-size: 12px;
        color: #999;
        text-decoration: none;
        &:hover {
          color: #e5322d;
        }
      }
      .mr {
        margin: 0 20px;
      }
    }
  }
}
</style>